import { useState, useEffect, useCallback, useRef } from 'react';
import { useRadioStream } from './useRadioStream';

export function usePlayer(streamUrl, apiUrl) {
    const {
        isPlaying,
        volume,
        metadata,
        elapsed,
        error,
        controls
    } = useRadioStream(streamUrl, apiUrl);

    const [currentSong, setCurrentSong] = useState(null);
    const [timeProgress, setTimeProgress] = useState(0);

    useEffect(() => {
        if (metadata?.now_playing) {
            setCurrentSong({
                title: metadata.now_playing.song.title,
                artist: metadata.now_playing.song.artist,
                album: metadata.now_playing.song.album,
                artwork: metadata.now_playing.song.art,
                duration: metadata.now_playing.duration,
                radioName: metadata.station?.name,
                isLive: metadata.live?.is_live || false,
                streamerName: metadata.live?.streamer_name || null
            });
        }
    }, [metadata]);

    // Calculate time progress as a percentage of the total duration
    useEffect(() => {
        if (elapsed && currentSong?.duration) {
            // Calculate percentage: (elapsed / duration) * 100
            // Make sure to handle edge cases where elapsed might exceed duration
            const percentage = Math.min((elapsed / currentSong.duration) * 100, 100);
            setTimeProgress(percentage);
        } else {
            setTimeProgress(0);
        }
    }, [elapsed, currentSong?.duration]);

    return {
        isPlaying,
        volume,
        currentSong,
        timeProgress,
        elapsed,
        error,
        controls,
        metadata
    };
} 